import React, { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Users, Inbox, Banknote, Clock, Award, CalendarDays } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { useAuth } from '../contexts/AuthContext';
import { useAccess } from '../context/AccessContext';
import { StaffRequestsTab } from '../components/staff/StaffRequestsTab';
import { AbsenceCalendarTab } from '../components/staff/AbsenceCalendarTab';
import Payslips from './Payslips';
import TimeTracking from './TimeTracking';
import InternshipCertificates from './InternshipCertificates';

const TABS = [
  { key: 'requests', label: 'Demandes', icon: Inbox, Comp: null, path: null },
  { key: 'calendar', label: 'Calendrier', icon: CalendarDays, Comp: AbsenceCalendarTab, path: null },
  { key: 'payslips', label: 'Bulletins de paie', icon: Banknote, Comp: Payslips, path: '/payslips' },
  { key: 'time', label: "Relevé d'heures", icon: Clock, Comp: TimeTracking, path: '/time-tracking' },
  { key: 'internships', label: 'Attestations de stage', icon: Award, Comp: InternshipCertificates, path: '/internship-certificates' },
];

export default function StaffManagement() {
  const { user } = useAuth();
  const { isAllowed, moduleForPath } = useAccess();
  const [params, setParams] = useSearchParams();
  const [pending, setPending] = useState(null);
  if (!['admin', 'super_admin'].includes(user?.role)) return <Navigate to="/my-hr" replace />;
  const tabs = TABS.filter((t) => !t.path || isAllowed(moduleForPath(t.path)));
  const current = tabs.some((t) => t.key === params.get('tab')) ? params.get('tab') : 'requests';

  return (
    <div className="space-y-6 pb-10" data-testid="staff-management-page">
      <div>
        <h1 className="text-3xl font-bold text-[#2B3A2C] flex items-center gap-2"><Users className="w-7 h-7 text-[#B85C38]" /> Gestion du personnel</h1>
        <p className="text-sm text-gray-600 mt-1">Demandes des collaborateurs, paie, heures et attestations, réunies au même endroit.</p>
      </div>
      <Tabs value={current} onValueChange={(v) => setParams({ tab: v }, { replace: true })} className="space-y-4">
        <TabsList className="bg-[#F5EFE1] h-auto flex-wrap justify-start w-full sm:w-auto">
          {tabs.map(({ key, label, icon: Icon }) => (
            <TabsTrigger key={key} value={key} data-testid={`staff-tab-${key}`}>
              <Icon className="w-4 h-4 mr-1" />{label}
              {key === 'requests' && pending > 0 && <span className="ml-1.5 rounded-full bg-[#B85C38] px-1.5 text-[10px] font-bold text-white" data-testid="staff-pending-count">{pending}</span>}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="requests"><StaffRequestsTab onCountChange={setPending} /></TabsContent>
        {tabs.filter((t) => t.Comp).map(({ key, Comp }) => (
          <TabsContent key={key} value={key} className="[&_h1]:text-xl [&_h1]:sm:text-2xl">{current === key && <Comp />}</TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
